import _asyncToGenerator from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Wallet from '../helpers/wallet-class';
import libMetamask from '../helpers/lib-metamask';
import capFirstChar from '../helpers/capitalize-first-character';
import isNode from '../../isNode';
import { later, delay } from '../../timers';
import managedPromise from '../../managedPromise';
import { cloneDeep, isEqual } from 'lodash';
var MetaMaskWallet = Wallet;
var CANCELLED = 'cancelled'; // signal that form is cancelled

var SIGNED = 'signed'; // signal that tx is signed

var DEFAULT_CONNECT_TIMEOUT_SEC = 300;
var WITH_METAMASK_ACCOUNTS = false; // not supported yet by metamask

if (!isNode) {
  // eslint-disable-next-line func-names
  (function (win) {
    var MetaMaskWindows = /*#__PURE__*/function (_Wallet) {
      _inherits(MetaMaskWindows, _Wallet);

      var _super = _createSuper(MetaMaskWindows);

      function MetaMaskWindows(validChainIds, usePolling) {
        var _this;

        _classCallCheck(this, MetaMaskWindows);

        _this = _super.call(this, validChainIds);

        var instance = _assertThisInitialized(_this);

        instance._refreshing = {};
        instance.name = 'metamask';
        instance._usePolling = usePolling;
        return _this;
      }

      _createClass(MetaMaskWindows, [{
        key: "_allPropsDefined",
        value: function _allPropsDefined(obj) {
          return !!obj.address && !!obj.chainId && !!obj.accounts;
        }
      }, {
        key: "_checkActivation",
        value: function _checkActivation(prop) {
          var instance = this;

          if (instance.activationPromise && instance.activationPromise.isPending()) {
            instance._activationProps[prop] = true;

            if (instance._allPropsDefined(instance._activationProps)) {
              if (instance.initializationPromise.isPending()) {
                instance.initializationPromise.fulfill(true);
                instance.forceUpdateContext();
              }

              instance.activationPromise.fulfill(true);
              instance.activated = true;
            }
          }
        }
      }, {
        key: "_refresh",
        value: function () {
          var _refresh2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(prop, initialization) {
            var instance, value, simpleType, propChanged;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    instance = this;

                    if (!(!initialization && instance._refreshing[prop])) {
                      _context.next = 3;
                      break;
                    }

                    return _context.abrupt("return");

                  case 3:
                    instance._refreshing[prop] = true;
                    _context.prev = 4;

                    if (!(!WITH_METAMASK_ACCOUNTS && prop === 'accounts')) {
                      _context.next = 9;
                      break;
                    }

                    value = instance.address ? [instance.address] : [];
                    _context.next = 12;
                    break;

                  case 9:
                    _context.next = 11;
                    return libMetamask["get".concat(capFirstChar(prop))]();

                  case 11:
                    value = _context.sent;

                  case 12:
                    instance.locked = !value;

                    if (!instance.locked) {
                      _context.next = 16;
                      break;
                    }

                    // willBeLocked: keep on using the data is it was before
                    instance._refreshing[prop] = false;
                    return _context.abrupt("return");

                  case 16:
                    simpleType = prop !== 'accounts';
                    propChanged = simpleType ? instance[prop] !== value : !isEqual(instance[prop], value);

                    if (propChanged) {
                      instance[prop] = simpleType ? value : cloneDeep(value);

                      if (!WITH_METAMASK_ACCOUNTS && prop === 'address') {
                        instance.accounts = [value];
                      }

                      if (!initialization || instance.activated) {
                        instance.forceUpdateContext();
                      }

                      if (!WITH_METAMASK_ACCOUNTS && prop === 'address') {
                        instance._checkActivation('accounts');
                      }
                    }

                    instance._checkActivation(prop);

                    _context.next = 25;
                    break;

                  case 22:
                    _context.prev = 22;
                    _context.t0 = _context["catch"](4);
                    console.error(_context.t0);

                  case 25:
                    instance._refreshing[prop] = false;

                  case 26:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this, [[4, 22]]);
          }));

          function _refresh(_x, _x2) {
            return _refresh2.apply(this, arguments);
          }

          return _refresh;
        }()
      }, {
        key: "_onConnect",
        value: function () {
          var _onConnect2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(timeoutSec) {
            var instance;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    instance = this;

                    if (!instance.activationPromise) {
                      instance.activationPromise = managedPromise(null, null, timeoutSec * 1000, '');
                    }

                    _context2.next = 4;
                    return instance._refresh('address', true);

                  case 4:
                    if (!(!instance.address && instance.activationPromise.isPending())) {
                      _context2.next = 11;
                      break;
                    }

                    _context2.next = 7;
                    return delay(2500);

                  case 7:
                    _context2.next = 9;
                    return instance._refresh('address', true);

                  case 9:
                    _context2.next = 4;
                    break;

                  case 11:
                    _context2.next = 13;
                    return instance._refresh('chainId', true);

                  case 13:
                    _context2.next = 15;
                    return instance._refresh('accounts', true);

                  case 15:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));

          function _onConnect(_x3) {
            return _onConnect2.apply(this, arguments);
          }

          return _onConnect;
        }()
      }, {
        key: "deactivate",
        value: function deactivate(keepPolling) {
          var instance = this;

          if (instance._usePolling && !keepPolling) {
            delete instance._polling;
          }

          if (instance.activationPromise) {
            if (instance.activationPromise.isPending()) {
              instance.activationPromise.reject();
            }

            delete instance.activationPromise;
          }

          instance._activationProps = {};

          _get(_getPrototypeOf(MetaMaskWindows.prototype), "deactivate", this).call(this);
        }
      }, {
        key: "cancelTimer",
        value: function cancelTimer() {
          if (this._timer) {
            this._timer.cancel();
          }
        }
      }, {
        key: "activate",
        value: function () {
          var _activate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            var timeoutSec,
                instance,
                installed,
                mm,
                _args3 = arguments;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    timeoutSec = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : DEFAULT_CONNECT_TIMEOUT_SEC;
                    instance = this;

                    if (!instance.activated) {
                      _context3.next = 4;
                      break;
                    }

                    return _context3.abrupt("return", true);

                  case 4:
                    if (!instance.activationPromise) {
                      _context3.next = 6;
                      break;
                    }

                    return _context3.abrupt("return", instance.activationPromise);

                  case 6:
                    if (instance._usePolling) {
                      _context3.next = 13;
                      break;
                    }

                    _context3.next = 9;
                    return libMetamask.isInstalled();

                  case 9:
                    installed = _context3.sent;

                    if (installed) {
                      _context3.next = 13;
                      break;
                    }

                    instance.emitter.emit('info', 'Please install MetaMask');
                    return _context3.abrupt("return", false);

                  case 13:
                    instance._activationProps = {};
                    instance.activationPromise = managedPromise(null, null, timeoutSec * 1000, '');

                    if (!(!instance._usePolling && !instance._eventListenersSet)) {
                      _context3.next = 20;
                      break;
                    }

                    _context3.next = 18;
                    return libMetamask.getMetaMask();

                  case 18:
                    mm = _context3.sent;

                    if (mm) {
                      instance._eventListenersSet = true;
                      mm.on('connect', function () {
                        instance.cancelTimer();

                        instance._onConnect(timeoutSec);
                      });
                      mm.on('disconnect', function () {
                        // we MAY need to deactivate, but not when a quick `connect` follows
                        // because, sometimes when changing from network, a quick disconnect+connect happen (not always)
                        // and when it does, disconnecting would bring some apps into a disconnected state
                        instance.cancelTimer();
                        instance._timer = later(instance.deactivate.bind(instance), 1000);
                      });
                      mm.on('chainChanged', instance._refresh.bind(instance, 'chainId', false));
                      mm.on('accountsChanged', function () {
                        instance._refresh('address');

                        instance._refresh('accounts');
                      });
                    }

                  case 20:
                    if (!instance._usePolling) {
                      _context3.next = 24;
                      break;
                    }

                    instance.pollWalletConnection();
                    _context3.next = 32;
                    break;

                  case 24:
                    _context3.prev = 24;
                    Promise.all([instance._refresh('address', true), instance._refresh('accounts', true), instance._refresh('chainId', true)]);
                    _context3.next = 32;
                    break;

                  case 28:
                    _context3.prev = 28;
                    _context3.t0 = _context3["catch"](24);
                    instance.emitter.emit('info', 'Please install MetaMask');
                    return _context3.abrupt("return", false);

                  case 32:
                    return _context3.abrupt("return", instance.activationPromise);

                  case 33:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, this, [[24, 28]]);
          }));

          function activate() {
            return _activate.apply(this, arguments);
          }

          return activate;
        }()
      }, {
        key: "networkConnected",
        value: function networkConnected() {
          var instance = this;
          return instance.activated && (!instance._validChainIds || instance._validChainIds.includes(instance.chainId));
        }
      }, {
        key: "sendTx",
        value: function () {
          var _sendTx = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(rawTx) {
            var response, instance, EVENT_SIGN_TRANSACTION;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    instance = this;
                    EVENT_SIGN_TRANSACTION = "Please sign your Transaction on your ".concat(capFirstChar(instance.name), " Wallet");
                    _context4.prev = 2;
                    instance.emitter.emit('info', EVENT_SIGN_TRANSACTION, true);
                    _context4.next = 6;
                    return libMetamask.sendTx(rawTx);

                  case 6:
                    response = _context4.sent;
                    instance.emitter.emit('cleanup', EVENT_SIGN_TRANSACTION);

                    if (response) {
                      instance.emitter.emit(SIGNED, SIGNED); // code for being signed
                    }

                    _context4.next = 15;
                    break;

                  case 11:
                    _context4.prev = 11;
                    _context4.t0 = _context4["catch"](2);
                    instance.emitter.emit('cleanup', EVENT_SIGN_TRANSACTION);
                    throw new Error(_context4.t0.code === 4100 ? 'Cannot send transaction: please unlock your Wallet first' : _context4.t0.message);

                  case 15:
                    return _context4.abrupt("return", response);

                  case 16:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, this, [[2, 11]]);
          }));

          function sendTx(_x4) {
            return _sendTx.apply(this, arguments);
          }

          return sendTx;
        }()
      }, {
        key: "switchToNetwork",
        value: function () {
          var _switchToNetwork = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(networkId) {
            var response, instance, EVENT_SWITCH_NETWORK;
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    instance = this;
                    EVENT_SWITCH_NETWORK = "Please use your ".concat(capFirstChar(instance.name), " Wallet to switch from Network");
                    _context5.prev = 2;
                    instance.emitter.emit('info', EVENT_SWITCH_NETWORK, true);
                    _context5.next = 6;
                    return libMetamask.switchToNetwork(networkId);

                  case 6:
                    response = _context5.sent;
                    instance.emitter.emit('cleanup', EVENT_SWITCH_NETWORK);
                    _context5.next = 15;
                    break;

                  case 10:
                    _context5.prev = 10;
                    _context5.t0 = _context5["catch"](2);
                    instance.emitter.emit('cleanup', EVENT_SWITCH_NETWORK);
                    instance.emitter.emit(CANCELLED, CANCELLED); // code for being cancelled

                    throw new Error(_context5.t0.code === 4100 ? 'Cannot send transaction: please unlock your Wallet first' : _context5.t0.message);

                  case 15:
                    return _context5.abrupt("return", response);

                  case 16:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, this, [[2, 10]]);
          }));

          function switchToNetwork(_x5) {
            return _switchToNetwork.apply(this, arguments);
          }

          return switchToNetwork;
        }()
      }, {
        key: "pollWalletConnection",
        value: function () {
          var _pollWalletConnection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
            var instance, firstLoop, hasErrored, prevAddress, prevChainId, prevAccounts;
            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    instance = this;

                    if (!(instance._usePolling && !instance._polling)) {
                      _context6.next = 38;
                      break;
                    }

                    instance._polling = true;
                    firstLoop = true;
                    hasErrored = false;

                  case 5:
                    if (!instance._polling) {
                      _context6.next = 38;
                      break;
                    }

                    prevAddress = instance.address;
                    prevChainId = instance.chainId;
                    prevAccounts = cloneDeep(instance.accounts);
                    _context6.prev = 9;

                    if (!firstLoop) {
                      _context6.next = 17;
                      break;
                    }

                    firstLoop = false;
                    _context6.next = 14;
                    return Promise.all([instance._refresh('address', true), instance._refresh('accounts', true), instance._refresh('chainId', true)]);

                  case 14:
                    if (instance.activated && !instance.address) {
                      instance.deactivate(true);
                    }

                    _context6.next = 27;
                    break;

                  case 17:
                    _context6.next = 19;
                    return instance._refresh('address');

                  case 19:
                    if (!(instance.activated && !instance.address)) {
                      _context6.next = 23;
                      break;
                    }

                    instance.deactivate(true);
                    _context6.next = 27;
                    break;

                  case 23:
                    _context6.next = 25;
                    return instance._refresh('chainId');

                  case 25:
                    _context6.next = 27;
                    return instance._refresh('accounts');

                  case 27:
                    hasErrored = false; // reset

                    _context6.next = 33;
                    break;

                  case 30:
                    _context6.prev = 30;
                    _context6.t0 = _context6["catch"](9);

                    if (!hasErrored) {
                      hasErrored = true;
                      instance.emitter.emit('info', 'Please install MetaMask');
                    }

                  case 33:
                    if (instance.activated && instance.activationPromise && instance.activationPromise.isFulfilled()) {
                      if (prevAddress !== instance.address || prevChainId !== instance.chainId || !isEqual(prevAccounts, instance.accounts)) {
                        instance.forceUpdateContext();
                      }
                    }

                    _context6.next = 36;
                    return delay(1200);

                  case 36:
                    _context6.next = 5;
                    break;

                  case 38:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6, this, [[9, 30]]);
          }));

          function pollWalletConnection() {
            return _pollWalletConnection.apply(this, arguments);
          }

          return pollWalletConnection;
        }()
      }]);

      return MetaMaskWindows;
    }(Wallet);

    MetaMaskWallet = MetaMaskWindows;
  })(typeof global !== 'undefined' ? global :
  /* istanbul ignore next */
  this);
}

export default MetaMaskWallet;